import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { InvoiceFormTypes } from "models/formTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { SendToDebtCollectionFormContainerProps } from "models/propTypes/invoicePropTypes";
import { SendToDebtCollection } from "models/formTypes/invoice";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import SendToDebtCollectionForm from "./sendToDebtCollectionForm";
import { useInvoiceService } from "serviceHooks";
//#endregion
import * as Yup from "yup";

const SendToDebtCollectionFormContainer: ForwardRefRenderFunction<
  FormHandles,
  SendToDebtCollectionFormContainerProps
> = (props, ref) => {
  const invoiceService = useInvoiceService();
  const validationSchema = Yup.object<InvoiceFormTypes.SendToDebtCollection>({
    note: Yup.string().required(TranslationKeys.Validations.Required),
  });

  const handleFormSubmit = (values: SendToDebtCollection) => {
    const sendToDebtCollectionForm: WintSuperkollAPIModel.SendToDebtCollectionForm = { note: values.note };
    const invoiceId = Number(props.invoiceId);
    return invoiceService.postClaim(invoiceId, sendToDebtCollectionForm);
  };

  return (
    <SendToDebtCollectionForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      handleSubmit={handleFormSubmit}
      defaultValues={{}}
    />
  );
};

export default forwardRef(SendToDebtCollectionFormContainer);
